<ion-content [fullscreen]="true">
   <div style="max-height: 100%;">
      <ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
      <!--(loopComplete)="onLoopComplete()"-->
   </div>
</ion-content>